const organisations = {
	title: "Organisasjoner",
	title_s: "Organisasjon",
	new_organisation: "Ny organisasjon",
	edit_organisation: "Rediger organisasjon: {name}",
	view_organisation: "Vis organisasjon: {name}",
	list_title: "Liste over organisasjoner",
	list_subtitle: "Håndtere organisasjoner",
	create_title: "Opprett organisasjon",
	update_title: "Endre organisasjon",
	details_title: "Organisasjonsdetaljer",
	visiting_address_title: "Besøksadresse",
	invoice_address_title: "Fakturaadresse",
	invoice_title: "Fakturadetaljer",
	id: "ID",
	name: "Navn",
	tenant_company: "Klient selskap",
	email: "Epost",
	vat: "Orgnr",
	phone: "Telefon",
	owner: "Systemeier",
	po_number: "PO",
	invoice_ref: "Referanse",
	email_invoice: "Faktura epost",
	same_as_visiting: "Samme som besøksadresse",
	customergroups: "Kundegrupper",
	member_organisation: "Medlemsorganisasjon",
	members_of: "Medlem av",
	certification_agencies: "Sertifisert",
	certification_authority: "Sertifiseringsorgan",
	certification_authority_short: "Sert. org.",
	sms_service: "SMS Service Status",
	upload_org_logo: "Last opp logo",
	upload_org_signature: "Last opp signatur",
	signature: "Signatur",
	visiting_street: "Adresse",
	visiting_city: "Sted",
	visiting_state: "Fylke",
	visiting_zip: "Postnr",
	visiting_country: "Land",
	invoice_street: "Adresse",
	invoice_city: "Sted",
	invoice_state: "Fylke",
	invoice_zip: "Postnr",
	invoice_country: "Land",
	show_logo: "Vis logo",
	upload_logo: "Last opp logo",
	update_logo: "Oppdater logo",
	uploaded_logo: "Logo ble lastet opp",
	updated_logo: "Logo ble oppdatert",
	remove_logo: "Fjern logo",
	upload_image: "Oppdater Logo",
	select_image: "Velg logo",
	upload_signature_digital: "Digital Signature",
	upload_signature: "Last opp/oppdater signatur",
	select_signature: "Velg signatur",
	sms_usage: "SMS forbruk",
	sms_select_year: "Velg år",
	org_does_not_exist: "Selskap er ikke funnet",
	vat_does_not_exist: "Orgnr eksisterer ikke",
	course_id_increment_start: "Kursnummer start",
	tenant_vat_number: "Klient orgnummer",
	notif_email_from: "Varsingsavsender epost",
	notif_sms_from: "Nummer for varslingsavsender",
	invalid_email: "Feil epostadresse",
	email_same: "Samme epost",
	sms_same: "Samme mobil",
	code_send: "Kode er sendt til:",
	cannot_generate_code: "Kode kunne ikke genereres. Feilen er logget. Prøv igjen senere.",
	incorrect_code: "Feil eller utløpt kode.",
	swagger_token: "Swagger Token",
	open_swagger: "Open Swagger",
	notif_email_not_verified: "Epost er ikke verifisert. Sjekk innboks.",
	notif_email_verified: "Verifisert",
	resend_verify: "Send på nytt/Verifiser",
	certification_id: "Sertifiserings / Godkjenning ID",
};
export default organisations;